import { useEffect } from 'react'

/**
 * Isolates selection reset policies based on external dependencies.
 *
 * Triggers:
 * - searchDeps: e.g. [debouncedSearchTerm, filterTerm]
 * - dataDeps: e.g. [result?.dataUpdatedAt, result?.isSuccess, result?.data]
 *
 * When any entry in the respective dependency arrays changes, clear() is called.
 */
export default function useSelectionResetEffects({
  searchDeps = [],
  dataDeps = [],
  clear
} = {}) {
  // Reset on search/filter changes
  useEffect(() => {
    if (typeof clear === 'function') clear()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, searchDeps)

  // Reset on data changes (e.g., react-query success/update)
  useEffect(() => {
    if (typeof clear === 'function') clear()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dataDeps)
}